module.exports = __webpack_public_path__ + "static/media/item_3_8_comp.97ac0192.png";